
import { Card, Col, Row, Spin, Typography } from "antd"
import { createSearchParams, useNavigate } from "react-router-dom"

import { SvgImage } from "@/components/_Shared/SvgImage/SvgImage"

import classes from "../../Account/Balance/Balance.module.scss"

import { useCustomerQuery } from "@/hook/Dictionaries/Customers/useCustomerQuery"

import { paths } from "@/router/paths"

import { getMoney } from "@/utils/formatNumber"


const { Title } = Typography

export type BalanceProps = {}

export const Balance = (props: BalanceProps) => {
  const { data: customers, isLoading: customersIsLoading } = useCustomerQuery()
  const navigate = useNavigate()

  const onClickOrderedBalance = () => navigate({
    pathname: paths.orders,
    search: createSearchParams({
      active: "true"
    }).toString()
  })

  const onClickBalanceOrAvailable = () => navigate(paths.finance)

  return (
    <Spin spinning={customersIsLoading}>
      <Row gutter={16}>
        <Col xs={24} md={8}>
          <Card
            onClick={onClickBalanceOrAvailable}
            bordered={false}
            size="small"
            className={classes.balanceCard}
          >
            <Title level={4}>{getMoney(
              customers?.response.data.reduce(
                (sum, current) => sum + current.balance,
                0
              ) ?? 0
            )}</Title>
            <h5>Баланс</h5>
            <SvgImage src="wallet-icon.svg" height={68} width={68} className={`${classes.balanceIconSvg} ${classes.wallet}`} />
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card
            onClick={onClickOrderedBalance}
            bordered={false}
            size="small"
            className={classes.balanceCard}
          >
            <Title level={4}>{getMoney(
              customers?.response.data.reduce(
                (sum, current) => sum + current.sumOrder,
                0
              ) ?? 0
            )}</Title>
            <h5>Сумма заказов в работе</h5>
            <SvgImage src="cyrcle-icon.svg" height={72} width={72} className={`${classes.balanceIconSvg} ${classes.cyrcle}`} />
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card
            onClick={onClickBalanceOrAvailable}
            bordered={false}
            size="small"
            className={classes.balanceCard}
          >
            <Title level={4}>{getMoney(
              customers?.response.data.reduce(
                (sum, current) => sum + current.availableSum,
                0
              ) ?? 0
            )}</Title>
            <h5>Сумма доступная для заказа</h5>
            <SvgImage src="check-icon.svg" height={65} width={65} className={`${classes.balanceIconSvg} ${classes.check}`} />
          </Card>
        </Col>
      </Row>
    </Spin>
  )
}